/**
 * @file 通用代码
 * @author qiaogang
 * @date 2019-12-12
 */
import { LogTrack, Log, auth } from '@igetcool/base-components';
import { Config } from './config';

// Log.config({
//   debug: true
// });

// auth.config({
//   passgoServer: Config.passgoServer,
//   appID:Config.snddwechatMiniAppId
// });
auth.config({
  passgoServer: Config.passgoServer
});

LogTrack.init();
